import { type UiLibI18n } from '@myre/domain-i18n-wordings';
import { wordingKeyEcho } from '@myre/ui-primitive-core';

import { InjectionToken } from '@angular/core';

/**
 * The wordings ui-primitive-charts reads. A frontend provides them from the
 * wordings it loaded, which type-checks them against the generated tree;
 * without one, each leaf answers its own key.
 */
export interface PrimitiveChartsWordings {
  _library: {
    legend: Pick<UiLibI18n['legend'], 'showLess' | 'showMore'>;
  };
}

export const PRIMITIVE_CHARTS_WORDINGS =
  new InjectionToken<PrimitiveChartsWordings>('PrimitiveChartsWordings', {
    providedIn: 'root',
    factory: () => wordingKeyEcho<PrimitiveChartsWordings>(),
  });
